import cx from 'classnames';

import { Heading } from 'components/Heading';

import { useNavigation } from 'hooks/navigation/useNavigation';
import { usePortfolioImages } from 'hooks/portfolio/usePortfolioImages';
import { usePreferences } from 'hooks/preferences/usePreferences';
import { useReviewsCarousel } from 'hooks/review/useReviewsCarousel';

import { CanvasAnimatedTile } from '../CanvasAnimatedTile';
import { CanvasReviews } from './CanvasReviews';

import s from './CanvasFooterReviews.module.css';

interface CanvasFooterReviewProps {
  areGiftCardsEnabled?: boolean;
}
const CanvasFooterReviews = ({}: // areGiftCardsEnabled,
CanvasFooterReviewProps) => {
  // Use first two images from portfolio for this section per design
  const { images } = usePortfolioImages();
  const { areGiftCardsEnabled } = usePreferences();

  const {
    currentReviewIndex,
    reviews,
    aboutLink,
    showNextReview,
    showPrevReview,
    showReviews,
  } = useReviewsCarousel({ maxCount: 200 });

  const { showPortfolio } = useNavigation();
  const noImage = !images || !images[0] || !images[0].image || !showPortfolio;
  const noSecondImage =
    !images || !images[1] || !images[1].image || !showPortfolio;

  return (
    <div className={s.root}>
      <CanvasAnimatedTile threshold={0.1}>
        <div className={s.container}>
          {areGiftCardsEnabled && (
            <div
              className={cx(s.row, s.row1, {
                [s.noImageGC]: noImage || !showPortfolio,
              })}
            >
              {images && images[0] && images[0].image && showPortfolio && (
                <img
                  className={cx(s.column, s.image)}
                  src={images[0].image.original}
                  alt="Gift Card"
                />
              )}
              <div className={cx(s.column, s.text)}>
                <div className={s.textContainer}>
                  <div
                    className={cx(s.giftCardSection, {
                      [s.noImage]: noImage || !showPortfolio,
                    })}
                  >
                    <Heading as="h2" variant="large">
                      Giftcards
                    </Heading>
                    <a href="/gift-cards" className={s.noBorder}>
                      <button
                        className={s.button}
                        aria-label="Buy Here"
                        title="Buy Here"
                      >
                        <span className={s.buttonText}>Buy Here</span>
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showReviews && (
            <div className={cx(s.row, s.row2)}>
              <CanvasReviews
                currentReviewIndex={currentReviewIndex}
                onShowNextReview={showNextReview}
                onShowPrevReview={showPrevReview}
                reviews={reviews}
                aboutLink={aboutLink}
                noImage={noSecondImage}
              />
              {images && images[1] && images[1].image && showPortfolio && (
                <img
                  className={cx(s.column, s.image)}
                  src={images[1].image.original}
                  alt="Review"
                />
              )}
            </div>
          )}
        </div>
      </CanvasAnimatedTile>
    </div>
  );
};

export { CanvasFooterReviews };
